// extracted by mini-css-extract-plugin
export default {"Product":"Product_Product__bt5X7"};